module.exports = __webpack_public_path__ + "img/lgads.1d863639.webp";